document.addEventListener('DOMContentLoaded', function() {

  // --- Helpers ---
  function getColor() {
    var current = document.querySelector('.color-swatch--current');
    if (!current) return '';
    var title = current.getAttribute('title') || '';
    var parts = title.split(' - ');
    return parts.length > 1 ? parts[parts.length - 1].trim() : '';
  }

  function getPrice() {
    var el = document.querySelector('.product-single__price');
    return el ? el.textContent.trim() : '';
  }

  function updateStickyName() {
    var nameEl = document.getElementById('sticky-name-21mars');
    var priceEl = document.getElementById('sticky-price-21mars');
    if (!nameEl) return;
    var title = document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : '';
    var color = getColor();
    var fullName = title;
    if (color) fullName += ' - ' + color;
    nameEl.textContent = fullName;
    if (priceEl) priceEl.textContent = getPrice();
  }

  function updateStickySize() {
    var checked = document.querySelector('.single-option-selector__radio:checked');
    if (!checked) return;
    document.querySelectorAll('.sticky-size-btn').forEach(function(btn) {
      btn.classList.toggle('selected', btn.dataset.value === checked.value);
    });
  }

  function buildSizeButtons() {
    var radios = document.querySelectorAll('.single-option-selector__radio');
    if (!radios.length) return '';
    var html = '<div class="sticky-sizes">';
    radios.forEach(function(radio) {
      var isDisabled = radio.classList.contains('disabled');
      var isChecked = radio.checked;
      html += '<button type="button" class="sticky-size-btn'
        + (isChecked ? ' selected' : '')
        + (isDisabled ? ' out-of-stock' : '')
        + '" data-value="' + radio.value + '"'
        + (isDisabled ? ' disabled' : '')
        + '>T' + radio.value + '</button>';
    });
    html += '</div>';
    return html;
  }

  // --- 1. Construire le sticky uniquement sur les fiches produit ---
  if (!document.querySelector('.product-form__cart-submit')) return;

  var stickyHTML = '<div id="sticky-cart-21mars">'
    + '<div class="sticky-inner">'
    + '<div class="sticky-info">'
    + '<div class="sticky-name" id="sticky-name-21mars"></div>'
    + '<div class="sticky-price" id="sticky-price-21mars"></div>'
    + '</div>'
    + '<div class="sticky-bottom-row">'
    + buildSizeButtons()
    + '<button class="sticky-btn" id="sticky-atc-btn">Ajouter au panier</button>'
    + '</div>'
    + '</div>'
    + '</div>';

  document.body.insertAdjacentHTML('beforeend', stickyHTML);
  updateStickyName();

  // --- 2. Clic sur taille dans le sticky ---
  document.querySelectorAll('.sticky-size-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var value = btn.dataset.value;
      var radio = document.querySelector('.single-option-selector__radio[value="' + value + '"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      document.querySelectorAll('.sticky-size-btn').forEach(function(b) {
        b.classList.toggle('selected', b.dataset.value === value);
      });
      updateStickyName();
    });
  });

  // --- 3. Mettre à jour au changement de taille sur la fiche ---
  document.querySelectorAll('.single-option-selector__radio').forEach(function(radio) {
    radio.addEventListener('change', function() {
      updateStickySize();
      updateStickyName();
    });
  });

  // --- 4. Brancher le bouton ATC ---
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var submitBtn = document.querySelector('[name="add"]');
  var stickyCart = document.getElementById('sticky-cart-21mars');

  if (stickyBtn && submitBtn) {
    stickyBtn.addEventListener('click', function() {
      stickyCart.classList.remove('visible');
      stickyCart.style.display = 'none';
      submitBtn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    });
  }

  // --- 5. Afficher/masquer selon visibilité du bouton ATC natif ---
  var addToCartBtn = document.querySelector('.product-form__cart-submit');

  if (!addToCartBtn || !stickyCart) return;

  var atcObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        stickyCart.classList.remove('visible');
      } else {
        stickyCart.classList.add('visible');
      }
    });
  }, { threshold: 0.5 });

  atcObserver.observe(addToCartBtn);

  // --- 6. Masquer le sticky quand le drawer panier est ouvert ---
  var drawerParent = document.querySelector('.js-mini-cart');

  if (drawerParent) {
    var drawerObserver = new MutationObserver(function() {
      if (drawerParent.classList.contains('active')) {
        stickyCart.classList.remove('visible');
      } else {
        var rect = addToCartBtn.getBoundingClientRect();
        var isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (!isVisible) {
          stickyCart.classList.add('visible');
        }
      }
    });

    drawerObserver.observe(drawerParent, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // --- 7. Franciser "Remove" dans le drawer ---
  var drawerObserverRemove = new MutationObserver(function() {
    document.querySelectorAll('.js-remove-mini-cart').forEach(function(btn) {
      if (btn.textContent.trim() === 'Remove') {
        btn.textContent = 'Supprimer';
      }
    });
  });

  if (document.querySelector('.js-mini-cart-content')) {
    drawerObserverRemove.observe(document.querySelector('.js-mini-cart-content'), {
      childList: true,
      subtree: true
    });
  }

  document.querySelectorAll('.js-remove-mini-cart').forEach(function(btn) {
    if (btn.textContent.trim() === 'Remove') {
      btn.textContent = 'Supprimer';
    }
  });

}); // fin DOMContentLoaded

// --- 8. Cross-sell fiches produit ---
function initCardsInSection(section) {
  section.querySelectorAll('.product-card').forEach(function(card) {
    if (card.dataset.crossSellInit) return;
    card.dataset.crossSellInit = 'true';

    var overlay = card.querySelector('.product-card__overlay');
    if (overlay) overlay.remove();
    var colorSwatches = card.querySelector('.product-card__color-swatches');
    if (colorSwatches) colorSwatches.remove();

    var cardInfo = card.querySelector('.product-card__info');
    if (cardInfo) {
      cardInfo.style.marginBottom = '0';
      cardInfo.style.paddingBottom = '0';
    }

    var buttons = card.querySelectorAll('.quick-add-btn');
    if (!buttons.length) return;

    var sizesHTML = '<div class="cross-sell-sizes" style="display:flex;justify-content:center;flex-wrap:wrap;gap:4px;padding:8px 8px 12px;">';
    buttons.forEach(function(btn) {
      sizesHTML += '<button class="cross-sell-size-btn" data-variant-id="'
        + btn.dataset.variantId
        + '" style="width:30px;height:30px;border:1px solid #ccc;background:#fff;border-radius:0px;font-size:11px;font-weight:600;cursor:pointer;color:#1a1a1a;padding:0;display:inline-flex;align-items:center;justify-content:center;line-height:1;box-sizing:border-box;">T'
        + btn.dataset.variantTitle + '</button>';
    });
    sizesHTML += '</div>';

    card.insertAdjacentHTML('beforeend', sizesHTML);

    card.querySelectorAll('.cross-sell-size-btn').forEach(function(sizeBtn) {
      sizeBtn.addEventListener('click', function() {
        sizeBtn.style.background = '#FE6D03';
        sizeBtn.style.borderColor = '#FE6D03';
        sizeBtn.style.color = '#fff';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: sizeBtn.dataset.variantId, quantity: 1 })
        }).then(function() {
          theme.miniCart.generateCart();
          theme.miniCart.updateElements();
          var cartBtn = document.querySelector('.js-toggle-cart');
          if (cartBtn) cartBtn.click();
          setTimeout(function() {
            sizeBtn.style.background = '#fff';
            sizeBtn.style.borderColor = '#ccc';
            sizeBtn.style.color = '#1a1a1a';
          }, 1000);
        });
      });
    });
  });
}

function observeSection(sectionId) {
  var section = document.getElementById(sectionId);
  if (!section) return;
  initCardsInSection(section);
  var obs = new MutationObserver(function() {
    if (section.querySelector('.product-card')) {
      initCardsInSection(section);
    }
  });
  obs.observe(section, { childList: true, subtree: true });
}

// Détection automatique des sections cross-sell
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.shopify-section').forEach(function(section) {
    if (section.id.includes('complementary') || section.id.includes('recommendations')) {
      observeSection(section.id);
    }
  });
});

// --- 9. Cross-sell page panier ---
(function() {
  if (!document.querySelector('.cart-table')) return;

  // Forcer le fond crème
  if (document.querySelector('.page-container')) {
    document.querySelector('.page-container').style.backgroundColor = '#fffdf2';
  }
  document.querySelectorAll('.cart__cell--image').forEach(function(el) {
    el.style.backgroundColor = '#fffdf2';
  });

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (!cart.items.length) return;

      var cartProductIds = cart.items.map(function(item) { return item.product_id; });
      var recommendedIds = [];
      var recommendedProducts = [];

      var promises = cart.items.map(function(item) {
        var limit = cart.items.length === 1 ? 3 : 5;
        return fetch('/recommendations/products.json?product_id=' + item.product_id + '&limit=' + limit + '&intent=complementary')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (cart.items.length === 1) {
              data.products.forEach(function(p) {
                if (cartProductIds.indexOf(p.id) === -1 && recommendedIds.indexOf(p.id) === -1 && recommendedProducts.length < 3) {
                  recommendedIds.push(p.id);
                  recommendedProducts.push(p);
                }
              });
            } else {
              var found = data.products.find(function(p) {
                return cartProductIds.indexOf(p.id) === -1 && recommendedIds.indexOf(p.id) === -1;
              });
              if (found) {
                recommendedIds.push(found.id);
                recommendedProducts.push(found);
              }
            }
          });
      });

      Promise.all(promises).then(function() {
        var products = recommendedProducts.slice(0, 3);
        if (!products.length) return;

        var html = '<div id="cart-cross-sell" style="margin-top:40px;padding-top:32px;border-top:1px solid #f0ede8;">'
          + '<h3 style="font-size:18px;font-weight:600;text-align:center;margin-bottom:24px;">Tu pourrais aussi aimer</h3>'
          + '<div style="display:flex;gap:16px;justify-content:center;flex-wrap:wrap;width:100%;overflow-x:auto;">';

        products.forEach(function(product) {
          var image = product.images.length ? 'https:' + product.images[0] : '';
          var price = (product.variants[0].price / 100).toFixed(2).replace('.', ',') + '€';

          html += '<div class="cart-cross-sell-card" style="width:clamp(140px, 30%, 240px);text-align:center;flex-shrink:0;">'
            + '<a href="/products/' + product.handle + '">'
            + '<img src="' + image + '" alt="' + product.title + '" style="width:100%;margin-bottom:8px;">'
            + '</a>'
            + '<div style="font-size:11px;font-weight:600;text-transform:uppercase;margin-bottom:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + product.title + '</div>'
            + '<div style="font-size:12px;color:#555;margin-bottom:10px;">' + price + '</div>'
            + '<div style="display:flex;justify-content:center;flex-wrap:wrap;gap:4px;margin-bottom:8px;">';

          product.variants.forEach(function(variant) {
            html += '<button class="cart-size-btn" data-variant-id="' + variant.id + '" '
              + 'style="width:30px;height:30px;border:1px solid #ccc;background:#fff;border-radius:4px;font-size:11px;font-weight:600;cursor:pointer;color:#1a1a1a;padding:0;display:inline-flex;align-items:center;justify-content:center;">T'
              + variant.title + '</button>';
          });

          html += '</div></div>';
        });

        html += '</div></div>';

        var cartTable = document.querySelector('.cart-table');
        cartTable.insertAdjacentHTML('afterend', html);
      });
    });
})();

// Délégation d'événement pour les boutons de taille du panier
document.addEventListener('click', function(e) {
  if (!e.target.classList.contains('cart-size-btn')) return;
  var btn = e.target;
  btn.style.background = '#FE6D03';
  btn.style.borderColor = '#FE6D03';
  btn.style.color = '#fff';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
  }).then(function() {
    setTimeout(function() {
      window.location.reload();
    }, 500);
  });
});

// ============================================================
// 21 MARS — Guide des tailles interactif V6
// À remplacer intégralement dans custom.js
// ============================================================
 
(function () {
 
  // ----------------------------------------------------------
  // DONNÉES
  // ----------------------------------------------------------
 
  const HAUTS = [
    { taille: '0', dosMin: 62, dosMax: 66, poitrineMin: 66, poitrineMax: 71,  fr: '70AA',                   us: '—',                    eu: '55AA' },
    { taille: '1', dosMin: 67, dosMax: 70, poitrineMin: 72, poitrineMax: 76,  fr: '75A / 70B',              us: '30A / 30B',              eu: '60A / 65B' },
    { taille: '2', dosMin: 68, dosMax: 71, poitrineMin: 77, poitrineMax: 83,  fr: '80A / 75B / 75C',        us: '30A / 32B / 32C',        eu: '65A / 70B / 70C' },
    { taille: '3', dosMin: 72, dosMax: 77, poitrineMin: 81, poitrineMax: 88,  fr: '80B / 80C / 85A / 85B',  us: '30B / 30C / 32A / 32B',  eu: '65B / 65C / 70A / 70B' },
    { taille: '4', dosMin: 78, dosMax: 86, poitrineMin: 89, poitrineMax: 98,  fr: '85C / 85D / 90A / 90B',  us: '32C / 32D / 34A / 34B',  eu: '70C / 70D / 75A / 75B' },
    { taille: '5', dosMin: 87, dosMax: 92, poitrineMin: 99, poitrineMax: 105, fr: '90D / 95A / 95B / 95C',  us: '34D / 36A / 36B / 36C',  eu: '75D / 80A / 80B / 80C' },
  ];
 
  const PETIT_DOS = [
    { taille: '3', dosMin: 58, dosMax: 61, poitrineMin: 72, poitrineMax: 78, joe: true },
    { taille: '4', dosMin: 62, dosMax: 65, poitrineMin: 79, poitrineMax: 88, joe: true },
    { taille: '5', dosMin: 66, dosMax: 69, poitrineMin: 89, poitrineMax: 98, joe: false },
  ];
 
  const BAS = [
    { taille: '0', bassMin: 65,  bassMax: 75,  mode: '10 ans', universel: 'XXS', fr: '34', eu: '30–32' },
    { taille: '1', bassMin: 75,  bassMax: 85,  mode: '12 ans', universel: 'XS',  fr: '36', eu: '32–34' },
    { taille: '2', bassMin: 85,  bassMax: 90,  mode: '14 ans', universel: 'S',   fr: '38', eu: '34–36' },
    { taille: '3', bassMin: 90,  bassMax: 95,  mode: '16 ans', universel: 'M',   fr: '40', eu: '36–38' },
    { taille: '4', bassMin: 95,  bassMax: 105, mode: '—',      universel: 'L',   fr: '42', eu: '38–40' },
    { taille: '5', bassMin: 105, bassMax: 115, mode: '—',      universel: 'XL',  fr: '44', eu: '40–42' },
  ];
 
  const IMG_POITRINE = 'https://cdn.shopify.com/s/files/1/0894/9917/3187/files/Tour_de_poitrine.jpg?v=1776788379';
  const IMG_DOS      = 'https://cdn.shopify.com/s/files/1/0894/9917/3187/files/Tour_de_dos.jpg?v=1776788379';
  const IMG_BASSIN   = 'https://cdn.shopify.com/s/files/1/0894/9917/3187/files/Tour_de_bassin.jpg?v=1776788379';
 
  // ----------------------------------------------------------
  // ALGORITHME
  // ----------------------------------------------------------
 
  // ALIGNE sur le calculateur de la page « guide des tailles » (source de verite).
  // Regle : la BANDE (tour de dos) doit tomber dans la tranche (strict) ;
  // parmi les tailles dont la bande convient, on prend le bonnet (tour de poitrine)
  // le plus proche, avec une tolerance de +/- 2 cm. Sinon : taille non disponible.
  function recommanderHaut(dos, poitrine) {
    // 1) Profil Petit Dos - correspondance exacte prioritaire.
    //    Nell couvre tout le Petit Dos ; Joe s'ajoute sur les bonnets les moins
    //    profonds (3PD/4PD) via le flag t.joe, Nell reste seul sur le 5PD.
    for (const t of PETIT_DOS) {
      if (dos >= t.dosMin && dos <= t.dosMax && poitrine >= t.poitrineMin && poitrine <= t.poitrineMax) {
        return { taille: t.taille, type: 'petit-dos', joe: t.joe, certain: true };
      }
    }
    // 2) Standard - bande stricte, puis bonnet le plus proche (tolerance +/- 2 cm)
    const TOL_DOS = 0, TOL_POI = 2;
    let best = null, bestDP = Infinity, bestDD = 0;
    for (const t of HAUTS) {
      const dD = Math.max(0, t.dosMin - dos, dos - t.dosMax);
      if (dD > TOL_DOS) continue;
      const dP = Math.max(0, t.poitrineMin - poitrine, poitrine - t.poitrineMax);
      if (dP < bestDP) { bestDP = dP; best = t; bestDD = dD; }
    }
    if (!best || bestDP > TOL_POI) return { taille: null, type: 'standard' };
    return { taille: best.taille, type: 'standard', certain: !(bestDD > 0 || bestDP > 0) };
  }

  // ALIGNE sur le calculateur de la page : tranche la plus proche, hors 65-115 cm => non disponible.
  function recommanderBas(bassin) {
    if (bassin < 65 || bassin > 115) return { taille: null, type: 'bas' };
    let best = null, bestD = Infinity;
    for (const t of BAS) {
      const d = Math.max(0, t.bassMin - bassin, bassin - t.bassMax);
      if (d < bestD) { bestD = d; best = t; }
    }
    return { taille: best.taille, type: 'bas', certain: bestD === 0 };
  }
 
  // ----------------------------------------------------------
  // DÉTECTION TYPE PRODUIT
  // ----------------------------------------------------------
 
  var forcedType = null; // forcé quand le drawer est ouvert depuis ailleurs (quick-add collections)
  function detecterTypeProduit() {
    if (forcedType) return forcedType;
    const tags  = (window.__21mars_product_tags || []).join(' ').toLowerCase();
    const type  = (window.__21mars_product_type || '').toLowerCase();
    const titre = document.title.toLowerCase();
    const texte = tags + ' ' + type + ' ' + titre;
    if (['culotte', 'shorty', 'les bas'].some(m => texte.includes(m))) return 'bas';
    if (['brassière', 'brassiere', 'soutien-gorge', 'soutien gorge', 'triangle', 'bandeau', 'cache-coeur', 'nell', 'les soutiens-gorge'].some(m => texte.includes(m))) return 'haut';
    return 'haut';
  }
 
 // ----------------------------------------------------------
  // TABLEAUX D'ÉQUIVALENCES HTML
  // ----------------------------------------------------------

  function htmlTableauHauts() {
    return `
      <p class="sg-table-title">Equivalences Tailles de Hauts</p>
      <div class="sg-table-scroll">
        <table class="sg-table">
          <thead><tr>
            <th>21 MARS</th><th>France</th><th>US / UK / CA</th><th>EU</th><th>Universel</th>
          </tr></thead>
          <tbody>
            <tr><td>0</td><td>70AA</td><td>—</td><td>55AA</td><td>XXS</td></tr>
            <tr><td>1</td><td>75A / 70B</td><td>30A / 30B</td><td>60A / 65B</td><td>XS</td></tr>
            <tr><td>2</td><td>80A / 75B / 75C</td><td>30A / 32B / 32C</td><td>65A / 70B / 70C</td><td>S</td></tr>
            <tr><td>3</td><td>80B / 80C / 85A / 85B</td><td>30B / 30C / 32A / 32B</td><td>65B / 65C / 70A / 70B</td><td>S/M</td></tr>
            <tr><td>4</td><td>85C / 85D / 90A / 90B</td><td>32C / 32D / 34A / 34B</td><td>70C / 70D / 75A / 75B</td><td>M/L</td></tr>
            <tr><td>5</td><td>90D / 95A / 95B / 95C</td><td>34D / 36A / 36B / 36C</td><td>75D / 80A / 80B / 80C</td><td>L/XL</td></tr>
          </tbody>
        </table>
      </div>
      <p class="sg-note">* Les équivalences internationales sont données à titre indicatif. La nomenclature varie selon les marques.</p>
      <p class="sg-table-title sg-table-title--mt">Mensurations spécifiques "Petit Dos"</p>
      <div class="sg-table-scroll">
        <table class="sg-table">
          <thead><tr>
            <th>21 MARS</th><th>France</th><th>US / UK / CA</th><th>EU</th><th>Modèles</th>
          </tr></thead>
          <tbody>
            <tr><td>3 Petit Dos</td><td>60A / 60B</td><td>28A / 28B</td><td>55A / 55B</td><td>Nell + Joe</td></tr>
            <tr><td>4 Petit Dos</td><td>65B / 65C</td><td>30B / 30C</td><td>60B / 60C</td><td>Nell + Joe</td></tr>
            <tr><td>5 Petit Dos</td><td>70C / 70D</td><td>32C / 32D</td><td>65C / 65D</td><td>Nell</td></tr>
          </tbody>
        </table>
      </div>
      </div>`;
  }

  function htmlTableauBas() {
    return `
      <p class="sg-table-title">Equivalences Tailles de Bas</p>
      <div class="sg-table-scroll">
        <table class="sg-table">
          <thead><tr>
            <th>21 MARS</th><th>Mode enfant</th><th>Universel</th><th>EU</th><th>FR prêt-à-porter</th>
          </tr></thead>
          <tbody>
            <tr><td>0</td><td>10 ans</td><td>XXS</td><td>30–32</td><td>34</td></tr>
            <tr><td>1</td><td>12 ans</td><td>XS</td><td>32–34</td><td>36</td></tr>
            <tr><td>2</td><td>14 ans</td><td>S</td><td>34–36</td><td>38</td></tr>
            <tr><td>3</td><td>16 ans</td><td>M</td><td>36–38</td><td>40</td></tr>
            <tr><td>4</td><td>—</td><td>L</td><td>38–40</td><td>42</td></tr>
            <tr><td>5</td><td>—</td><td>XL</td><td>40–42</td><td>44</td></tr>
          </tbody>
        </table>
      </div>`;
  }

  // ----------------------------------------------------------
  // HTML FORMULAIRE (section calculer)
  // ----------------------------------------------------------
 
  function htmlFormulaireHaut() {
    return `
      <div class="sg-form" id="sg-form">
        <div class="sg-champ">
          <img class="sg-champ-img sg-champ-img--dos" src="${IMG_DOS}" alt="Tour de dos">
          <p class="sg-champ-label">A. Tour de dos <span class="sg-unit">(en cm)</span></p>
          <p class="sg-champ-instruction">Place le mètre ruban juste sous la poitrine, là où se positionne l\u2019élastique d\u2019une brassière ou d\u2019un soutien-gorge.</p>
          <input class="sg-input" type="number" id="sg-dos" placeholder="ex. 72" min="50" max="110">
        </div>
        <div class="sg-champ">
          <img class="sg-champ-img" src="${IMG_POITRINE}" alt="Tour de poitrine">
          <p class="sg-champ-label">B. Tour de poitrine <span class="sg-unit">(en cm)</span></p>
          <p class="sg-champ-instruction">Place le mètre ruban bien à plat dans le dos et reviens sur le devant de la poitrine sans serrer. Le mètre doit être positionné sur la pointe des seins, là où le tour sera le plus large.</p>
          <input class="sg-input" type="number" id="sg-poitrine" placeholder="ex. 83" min="55" max="120">
        </div>
        <button class="sg-cta-btn" id="sg-cta">Trouver ma taille</button>
      </div>`;
  }
 
  function htmlFormulaireBas() {
    return `
      <div class="sg-form" id="sg-form">
        <div class="sg-champ">
          <img class="sg-champ-img" src="${IMG_BASSIN}" alt="Tour de bassin">
          <p class="sg-champ-label">A. Tour de bassin <span class="sg-unit">(en cm)</span></p>
          <p class="sg-champ-instruction">Positionne le mètre ruban autour des hanches, au niveau le plus fort des fesses, sans serrer.</p>
          <input class="sg-input" type="number" id="sg-bassin" placeholder="ex. 88" min="55" max="130">
        </div>
        <button class="sg-cta-btn" id="sg-cta">Trouver ma taille</button>
      </div>`;
  }

  // ----------------------------------------------------------
  // MODE « MA TAILLE HABITUELLE » (aligné sur la page /pages/guide-des-tailles)
  // ----------------------------------------------------------

  // Construit les <optgroup> par système à partir des équivalences (dédoublonnées).
  function sizeOptionsSG(rows, systems) {
    let html = '<option value="">— Choisis ta taille —</option>';
    systems.forEach(function (sy) {
      var seen = {}, opts = '';
      rows.forEach(function (r, i) {
        var v = r[sy[1]];
        if (v == null || v === '—') return;
        String(v).split('/').forEach(function (sz) {
          sz = sz.trim();
          if (!sz) return;
          if (sy[2] === 'num' && !/^[0-9]/.test(sz)) return;
          if (seen[sz]) return;
          seen[sz] = 1;
          opts += '<option value="' + i + '">' + sz + '</option>';
        });
      });
      if (opts) html += '<optgroup label="' + sy[0] + '">' + opts + '</optgroup>';
    });
    return html;
  }

  function htmlFormulaireTailleHaut() {
    return `
      <div class="sg-form-taille" id="sg-form">
        <p class="sg-champ-label">Ta taille de soutien-gorge habituelle</p>
        <p class="sg-champ-instruction">Choisis le système que tu connais (France, EU, US/UK). Ces correspondances sont indicatives : en cas de doute, fie-toi à tes mensurations.</p>
        <select class="sg-select" id="sg-select-haut">${sizeOptionsSG(HAUTS, [['France','fr','num'],['EU','eu','num'],['US / UK','us','num']])}</select>
      </div>`;
  }

  function htmlFormulaireTailleBas() {
    return `
      <div class="sg-form-taille" id="sg-form">
        <p class="sg-champ-label">Ta taille habituelle</p>
        <p class="sg-champ-instruction">Choisis le repère que tu connais (âge, universel, France, EU). Ces correspondances sont indicatives : en cas de doute, fie-toi à tes mensurations.</p>
        <select class="sg-select" id="sg-select-bas">${sizeOptionsSG(BAS, [['Âge','mode'],['Universel','universel'],['France','fr','num'],['EU','eu','num']])}</select>
      </div>`;
  }

  // Encart « Le savais-tu ? » affiché quand le résultat vient d'une taille habituelle.
  function sgCaveatHTML(size) {
    size = size || '90B';
    return `<div class="sg-caveat"><strong>* Le savais-tu ?</strong> Les tailles ne sont pas universelles — un ${size} change d'une marque à l'autre. Ces correspondances restent donc indicatives : pour être sûre, fie-toi à tes mensurations. Nos tailles, elles, sont pensées pour la morphologie des ados.</div>`;
  }

  // Sélecteur de mode + corps (formulaire du mode actif). Mesures par défaut.
  var sgMode = 'mesures';
  function htmlCalculer() {
    const estHaut = detecterTypeProduit() === 'haut';
    const mesures = estHaut ? htmlFormulaireHaut() : htmlFormulaireBas();
    const taille  = estHaut ? htmlFormulaireTailleHaut() : htmlFormulaireTailleBas();
    return `
      <p class="sg-mode-label">2 possibilités pour trouver ta taille :</p>
      <div class="sg-mode-switch">
        <button type="button" class="sg-mode-btn${sgMode === 'mesures' ? ' sg-mode-active' : ''}" data-mode="mesures">1. Je renseigne mes mesures</button>
        <button type="button" class="sg-mode-btn${sgMode === 'taille' ? ' sg-mode-active' : ''}" data-mode="taille">2. Je renseigne ma taille habituelle *</button>
      </div>
      <div id="sg-mode-body">${sgMode === 'taille' ? taille : mesures}</div>`;
  }

  function setSgMode(mode) {
    sgMode = mode;
    const estHaut = detecterTypeProduit() === 'haut';
    const body = document.getElementById('sg-mode-body');
    if (body) body.innerHTML = mode === 'taille'
      ? (estHaut ? htmlFormulaireTailleHaut() : htmlFormulaireTailleBas())
      : (estHaut ? htmlFormulaireHaut() : htmlFormulaireBas());
    document.querySelectorAll('.sg-mode-btn').forEach(b => b.classList.toggle('sg-mode-active', b.dataset.mode === mode));
    bindBody();
  }

  function calcFromSizeSG(type) {
    const estHaut = type === 'haut';
    const sel = document.getElementById(estHaut ? 'sg-select-haut' : 'sg-select-bas');
    const content = document.getElementById('sg-acc-calculer-content');
    if (!sel || !content) return;
    if (sel.value === '' || sel.value == null) return;
    const i = parseInt(sel.value);
    const row = estHaut ? HAUTS[i] : BAS[i];
    if (!row) return;
    const label = (sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text.trim() : '') || '90B';
    const resultat = { taille: row.taille, type: estHaut ? 'standard' : 'bas', certain: true };
    content.innerHTML = htmlResultat(resultat, resultat.type, label);
    bindModifier();
  }

  // ----------------------------------------------------------
  // HTML RÉSULTAT
  // ----------------------------------------------------------

  function htmlResultat(resultat, type, caveat) {
    if (!resultat || !resultat.taille) {
      return `
        <div class="sg-resultat-wrap">
          <p class="sg-result-label">Taille non trouvée</p>
          <p class="sg-result-conseil">Ces mensurations ne correspondent pas encore à nos tailles actuelles. Si tu ne l'as pas encore fait, inscris-toi à notre newsletter, on ne sait jamais ce que la prochaine collection nous réserve! </p>
          <button class="sg-modifier-btn" id="sg-modifier">← Modifier mes mesures</button>
        </div>`;
    }

    let conseil = '', badge = '', modeles = '';

    if (type === 'petit-dos') {
      badge = '<span class="sg-badge">Profil Petit Dos</span>';
      if (resultat.joe) {
        modeles = `
          <div class="sg-modeles">
            <p class="sg-modeles-label">Modèles recommandés</p>
            <div class="sg-modeles-list">
              <span class="sg-modele-tag">Nell</span>
              <span class="sg-modele-sep">ou</span>
              <span class="sg-modele-tag">Joe</span>
            </div>
          </div>`;
conseil = `Selon nous, cette taille est la bonne. Le <strong><a href="/products/brassiere-nell-marine" target="_blank">cache-cœur Nell</a></strong> et la <strong><a href="/products/brassiere-joe-marine" target="_blank">brassière Joe</a></strong> sont toutes les deux conçues pour ce profil spécifique "dos fin, poitrine développée".`;      } else {
        modeles = `
          <div class="sg-modeles">
            <p class="sg-modeles-label">Modèle recommandé</p>
            <div class="sg-modeles-list"><span class="sg-modele-tag">Nell</span></div>
          </div>`;
        conseil = `Selon nous, cette taille est la bonne. Notre <strong><a href="/products/brassiere-nell-marine" target="_blank">cache-cœur Nell</a></strong> propose une gamme de tailles spécifiquement conçus pour les dos fins avec une poitrine déjà bien développée.`;
      }
    } else if (resultat.limite) {
      conseil = `Selon nous, cette taille devrait convenir, mais si tu hésites ou a le moindre doute, écris-nous sur hello@21mars.com, nous prendrons contact avec toi pour te conseiller.`;
    } else if (!resultat.certain) {
      conseil = `Selon nous, cette taille est la bonne. Si tu hésites entre deux tailles, prends toujours la plus grande pour plus de confort. Si tu as le moindre doute, n'hésite pas à nous écrire sur hello@21mars.com, nous prendrons contact avec toi pour te conseiller.`;
    } else {
      conseil = `Selon nous, cette taille est la bonne.`;
    }

    return `
      <div class="sg-resultat-wrap">
        ${badge}
        <p class="sg-result-label">Taille recommandée</p>
        <div class="sg-result-taille-box">${type === 'petit-dos' ? resultat.taille + ' PD' : resultat.taille}</div>
        <p class="sg-result-conseil${caveat ? ' sg-result-conseil--center' : ''}">${conseil}</p>
        ${caveat ? sgCaveatHTML(caveat) : ''}
        ${modeles}
        <p class="sg-result-modele-hint">La taille, c\u2019est un point de départ. L\u2019âge, la corpulence et la forme de la poitrine jouent tout autant dans le choix du bon modèle. Nous te suggérons donc aussi d'aller jeter un oeil à l'ensemble de nos modèles disponibles avant de faire ton choix.  <a href="/pages/bien-choisir-son-modele" target="_blank">→ Découvrir nos modèles</a></p>
        <button class="sg-modifier-btn" id="sg-modifier">← Modifier mes mesures</button>
      </div>`;
  }
 
  // ----------------------------------------------------------
  // HTML MODALE COMPLÈTE
  // ----------------------------------------------------------
 
  function creerModale() {
    const estHaut = detecterTypeProduit() === 'haut';
 
    const html = `
      <div class="sg-overlay" id="sg-overlay" role="dialog" aria-modal="true" aria-label="Guide des tailles 21 MARS">
        <div class="sg-drawer" id="sg-drawer">
 
          <!-- Handle -->
          <div class="sg-handle"></div>
 
          <!-- Header -->
          <div class="sg-drawer-header">
            <p class="sg-eyebrow">Guide des tailles</p>
            <h2 class="sg-title">${estHaut ? 'Les hauts' : 'Les bas'}</h2>
            <button class="sg-close" id="sg-close" aria-label="Fermer">✕</button>
          </div>
 
          <!-- Section Calculer -->
          <div class="sg-accordion" id="sg-acc-calculer">
            <button class="sg-acc-trigger" id="sg-acc-calculer-btn">
              <span>Calculer ma taille</span>
              <span class="sg-acc-icon" id="sg-acc-calculer-icon">+</span>
            </button>
            <div class="sg-acc-content" id="sg-acc-calculer-content">
              ${htmlCalculer()}
            </div>
          </div>
 
          <!-- Section Équivalences -->
          <div class="sg-accordion" id="sg-acc-equiv">
            <button class="sg-acc-trigger" id="sg-acc-equiv-btn">
              <span>Tableau des équivalences</span>
              <span class="sg-acc-icon" id="sg-acc-equiv-icon">+</span>
            </button>
            <div class="sg-acc-content" id="sg-acc-equiv-content">
              <div class="sg-table-wrap">
                ${estHaut ? htmlTableauHauts() : htmlTableauBas()}
              </div>
            </div>
          </div>
 
        </div>
      </div>`;
 
    document.body.insertAdjacentHTML('beforeend', html);
  }
 
  // ----------------------------------------------------------
  // ACCORDION
  // ----------------------------------------------------------
 
  function toggleAccordion(contentId, iconId) {
    const content = document.getElementById(contentId);
    const icon    = document.getElementById(iconId);
    if (!content) return;
    const isOpen = content.classList.contains('sg-acc-open');
    content.classList.toggle('sg-acc-open', !isOpen);
    if (icon) icon.textContent = isOpen ? '+' : '−';
  }
 
  // ----------------------------------------------------------
  // CALCUL ET AFFICHAGE RÉSULTAT
  // ----------------------------------------------------------
 
  function calculerEtAfficher() {
    const type    = detecterTypeProduit();
    const form    = document.getElementById('sg-form');
    const content = document.getElementById('sg-acc-calculer-content');
    if (!form || !content) return;
 
    let resultat, typeRes;
 
    if (type === 'haut') {
      const dos      = parseFloat(document.getElementById('sg-dos')?.value);
      const poitrine = parseFloat(document.getElementById('sg-poitrine')?.value);
      if (!dos || !poitrine) {
        // Highlight champs vides
        if (!dos) document.getElementById('sg-dos')?.classList.add('sg-input-error');
        if (!poitrine) document.getElementById('sg-poitrine')?.classList.add('sg-input-error');
        return;
      }
      resultat = recommanderHaut(dos, poitrine);
      typeRes  = resultat.type;
    } else {
      const bassin = parseFloat(document.getElementById('sg-bassin')?.value);
      if (!bassin) {
        document.getElementById('sg-bassin')?.classList.add('sg-input-error');
        return;
      }
      resultat = recommanderBas(bassin);
      typeRes  = 'bas';
    }
 
    // Remplace le formulaire par le résultat
    content.innerHTML = htmlResultat(resultat, typeRes);
    bindModifier();
  }

  // Ré-affiche le sélecteur de mode + le formulaire du mode courant.
  function bindModifier() {
    const content = document.getElementById('sg-acc-calculer-content');
    document.getElementById('sg-modifier')?.addEventListener('click', function () {
      if (content) content.innerHTML = htmlCalculer();
      bindCalculer();
    });
  }

  // Bind du corps du mode actif : CTA (mesures) OU select (taille habituelle).
  function bindBody() {
    document.getElementById('sg-cta')?.addEventListener('click', calculerEtAfficher);
    document.querySelectorAll('.sg-input').forEach(input => {
      input.addEventListener('input', () => input.classList.remove('sg-input-error'));
    });
    document.getElementById('sg-select-haut')?.addEventListener('change', () => calcFromSizeSG('haut'));
    document.getElementById('sg-select-bas')?.addEventListener('change', () => calcFromSizeSG('bas'));
  }

  // Bind du sélecteur de mode + du corps.
  function bindCalculer() {
    document.querySelectorAll('.sg-mode-btn').forEach(btn => {
      btn.addEventListener('click', () => setSgMode(btn.dataset.mode));
    });
    bindBody();
  }
  // Alias de compat (ancien nom appelé à l'ouverture).
  function bindCta() { bindCalculer(); }
  
  // ----------------------------------------------------------
  // OUVERTURE / FERMETURE
  // ----------------------------------------------------------
 
function ouvrirModale() {
    let overlay = document.getElementById('sg-overlay');
    if (!overlay) {
      creerModale();
      overlay = document.getElementById('sg-overlay');

      // Accordion calculer
      document.getElementById('sg-acc-calculer-btn')?.addEventListener('click', function() {
        toggleAccordion('sg-acc-calculer-content', 'sg-acc-calculer-icon');
      });

      // Accordion équivalences
      document.getElementById('sg-acc-equiv-btn')?.addEventListener('click', function() {
        toggleAccordion('sg-acc-equiv-content', 'sg-acc-equiv-icon');
      });

      // CTA
      bindCta();

      // Fermeture
      const closeBtn = document.getElementById('sg-close');
      if (closeBtn) closeBtn.onclick = function(e) {
        e.stopPropagation();
        fermerModale();
      };
      overlay.addEventListener('click', e => { if (e.target === overlay) fermerModale(); });
      document.addEventListener('keydown', e => { if (e.key === 'Escape') fermerModale(); });
    }

    // Ouvre l'accordion calculer par défaut
    const calcContent = document.getElementById('sg-acc-calculer-content');
    const calcIcon    = document.getElementById('sg-acc-calculer-icon');
    if (calcContent && !calcContent.classList.contains('sg-acc-open')) {
      calcContent.classList.add('sg-acc-open');
      if (calcIcon) calcIcon.textContent = '−';
    }

    overlay.classList.add('sg-visible');
    document.body.style.overflow = 'hidden';
    const stickyCart = document.getElementById('sticky-cart-21mars');
    if (stickyCart) stickyCart.style.display = 'none';
  }

  function fermerModale() {
    const overlay = document.getElementById('sg-overlay');
    if (overlay) {
      overlay.classList.remove('sg-visible');
      document.body.style.overflow = '';
    }
    const stickyCart = document.getElementById('sticky-cart-21mars');
    if (stickyCart) stickyCart.style.display = '';
  }
 
  // ----------------------------------------------------------
  // INJECTION
  // ----------------------------------------------------------
 
  function injecterBouton() {
    document.querySelectorAll('a.open-sizeguide').forEach(function(lien) {
      if (lien.dataset.sgInit) return;
      lien.dataset.sgInit = '1';
      lien.setAttribute('href', 'javascript:void(0)');
      lien.onclick = function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        forcedType = null;
        ouvrirModale();
        return false;
      };
    });
  }
 
  // ----------------------------------------------------------
  // INIT
  // ----------------------------------------------------------
 
  function init() {
    if (!document.querySelector('.product') && !document.querySelector('[data-section-type="product"]')) return;
    injecterBouton();
    new MutationObserver(() => {
      if (!document.querySelector('a.open-sizeguide[data-sg-init]')) injecterBouton();
    }).observe(document.body, { childList: true, subtree: true });
  }
 
  // Ouvre le drawer de tailles depuis n'importe où (ex : quick-add des collections).
  window.SizeGuide21 = {
    open: function (type) {
      forcedType = (type === 'bas') ? 'bas' : 'haut';
      var ex = document.getElementById('sg-overlay');
      if (ex) ex.remove();          // reconstruit avec le bon type
      sgMode = 'mesures';           // ouvre en mode mesures
      ouvrirModale();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();
/* ===================================================================
   21 MARS · Description produit « Lire la suite » (MOBILE)
   Tronque .product-short__description à 3 lignes + lien d'expansion.
   N'ajoute le lien que si le texte déborde. À coller à la FIN de custom.js.
   =================================================================== */
(function () {
  'use strict';
  var LINES = 3;
  function isMobile(){ return window.innerWidth < 1000; }

  function clamp(el){
    el.style.display = '-webkit-box';
    el.style.webkitBoxOrient = 'vertical';
    el.style.webkitLineClamp = String(LINES);
    el.style.overflow = 'hidden';
  }
  function unclamp(el){
    el.style.display = '';
    el.style.webkitBoxOrient = '';
    el.style.webkitLineClamp = '';
    el.style.overflow = '';
  }

  function init(){
    if (!isMobile()) return;
    var d = document.querySelector('.product-short__description');
    if (!d || d.dataset.rmInit) return;
    d.dataset.rmInit = '1';

    clamp(d);
    // Pas de débordement -> on retire le clamp, pas de bouton
    if (d.scrollHeight <= d.clientHeight + 2){ unclamp(d); return; }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rm-toggle';
    btn.textContent = 'Lire la suite';
    btn.style.cssText = 'display:inline-block;margin-top:8px;background:none;border:none;padding:0;'
      + 'color:#FE6D03;font-weight:700;font-size:14px;font-family:inherit;cursor:pointer;'
      + 'text-decoration:underline;text-underline-offset:3px;';
    d.parentNode.insertBefore(btn, d.nextSibling);

    var open = false;
    btn.addEventListener('click', function(){
      open = !open;
      if (open){ unclamp(d); btn.textContent = 'Lire moins'; }
      else { clamp(d); btn.textContent = 'Lire la suite'; }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();